"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _avlFalcor = require("../avl-falcor");

var avlFalcorWrapper = function avlFalcorWrapper(Component) {
  return (0, _avlFalcor.avlFalcor)(Component);
};

var _default = avlFalcorWrapper;
exports["default"] = _default;